import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { resetPassword } from '../services/api';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error('Passwords do not match');
    if (form.password.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      await resetPassword(token, { password: form.password });
      toast.success('Password updated successfully');
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Unable to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-yamass-cream flex items-center justify-center px-4 py-12">
      <div className="bg-white rounded-3xl shadow-sm p-10 w-full max-w-md">
        <h1 className="font-display text-3xl font-bold text-yamass-black mb-2">Choose a new password</h1>
        <p className="text-gray-400 text-sm mb-8">Enter your new password below.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wider block mb-1">New password</label>
            <input
              type="password"
              required
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-yamass-accent"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wider block mb-1">Confirm password</label>
            <input
              type="password"
              required
              value={form.confirm}
              onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-yamass-accent"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-yamass-black text-white py-4 rounded-full text-sm font-semibold hover:bg-yamass-accent transition-colors disabled:opacity-50 mt-2"
          >
            {loading ? 'Updating password...' : 'Reset password'}
          </button>
        </form>
        <p className="text-center text-sm text-gray-400 mt-6">
          Need to sign in? <Link to="/login" className="text-yamass-accent font-medium hover:underline">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
